// utils/translations/QuestionsTranslations.js

const translations = {
    fr: {
      questionLabel: "Question",
      yourAnswer: "Votre réponse",
      validateAnswer: "Valider ma réponse",
      pleaseSelectAnAnswer: "Veuillez sélectionner une réponse.",
      correctAnswer: "Bonne réponse !",
      tryAgain: "Essaie encore...",
      nextQuestion: "Question Suivante",
      retry: "Réessayer",
      finishGame: "Terminer",
      noHintAvailable: "Aucun indice disponible.",
      closeButton: "Fermer"
    },
    en: {
      questionLabel: "Question",
      yourAnswer: "Your answer",
      validateAnswer: "Validate my answer",
      pleaseSelectAnAnswer: "Please select an answer.",
      correctAnswer: "Correct answer!",
      tryAgain: "Try again...",
      nextQuestion: "Next question",
      retry: "Retry",
      finishGame: "Finish",
      noHintAvailable: "No hint available.",
      closeButton: "Close"
    },
    de: {
      questionLabel: "Frage",
      yourAnswer: "Ihre Antwort",
      validateAnswer: "Antwort bestätigen",
      pleaseSelectAnAnswer: "Bitte wählen Sie eine Antwort aus.",
      correctAnswer: "Richtige Antwort!",
      tryAgain: "Versuche es noch einmal...",
      nextQuestion: "Nächste Frage",
      retry: "Erneut versuchen",
      finishGame: "Beenden",
      noHintAvailable: "Kein Hinweis verfügbar.",
      closeButton: "Schließen"
    },
    es: {
      questionLabel: "Pregunta",
      yourAnswer: "Tu respuesta",
      validateAnswer: "Validar mi respuesta",
      pleaseSelectAnAnswer: "Por favor, seleccione una respuesta.",
      correctAnswer: "¡Respuesta correcta!",
      tryAgain: "Inténtalo de nuevo...",
      nextQuestion: "Siguiente pregunta",
      retry: "Reintentar",
      finishGame: "Finalizar",
      noHintAvailable: "No hay pistas disponibles.",
      closeButton: "Cerrar"
    },
    it: {
      questionLabel: "Domanda",
      yourAnswer: "La tua risposta",
      validateAnswer: "Conferma la mia risposta",
      pleaseSelectAnAnswer: "Seleziona una risposta, per favore.",
      correctAnswer: "Risposta corretta!",
      tryAgain: "Riprova...",
      nextQuestion: "Prossima domanda",
      retry: "Riprova",
      finishGame: "Finisci",
      noHintAvailable: "Nessun indizio disponibile.",
      closeButton: "Chiudi"
    }
  };
  
  export default translations;
  